import { HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { tap } from "rxjs";
import { SUCCESS_TOAST } from "./snackbar.tokens";

export const httpSuccessInterceptor: HttpInterceptorFn = (req, next) => {
  const snack = inject(MatSnackBar);
  const message = req.context.get(SUCCESS_TOAST); // string | null

  return next(req).pipe(
    tap((event) => {
      if (message && event instanceof HttpResponse) {
        snack.open(message, "Close", {
          duration: 3000,
          panelClass: ["snackbar-success"],
        });
      }
    })
  );
};
